export default __webpack_public_path__ + "static/media/image15.b601ac37.svg";